import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiGlobe, FiHeart } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import logoLight from '../../images/logo-light.svg';

const AppFooter = () => {
	const currentYear = new Date().getFullYear();

	const footerLinks = [
		{
			title: 'Quick Links',
			links: [
				{ name: 'Home', path: '/' },
				{ name: 'Projects', path: '/projects' },
				{ name: 'About', path: '/about' },
				{ name: 'Contact', path: '/contact' }
			]
		},
		{
			title: 'Services',
			links: [
				{ name: 'Web Development', path: '/projects' },
				{ name: 'Mobile Apps', path: '/projects' },
				
			]
		},
		{
			title: 'Technologies',
			links: [
				{ name: 'React & Next.js', path: '/projects' },
				{ name: 'Flutter & React Native', path: '/projects' },
				{ name: 'Node.js & Python', path: '/projects' },
				{ name: 'AWS & Firebase', path: '/projects' }
			]
		}
	];

	const socialLinks = [
		{ icon: FiGithub, href: 'https://github.com/AwaisKhan74', label: 'GitHub' },
		{ icon: FiLinkedin, href: 'https://www.linkedin.com/in/awais-khan-61aa94248/', label: 'LinkedIn' },
		{ icon: FiGlobe, href: 'https://www.upwork.com/freelancers/~01478d510333313346?mp_source=share', label: 'Upwork' },
		{ icon: FiGlobe, href: 'https://www.fiverr.com/s/7Yy2z51?utm_source=CopyLink_Mobile', label: 'Fiverr' }
	];

	return (
		<footer className="bg-gray-900 text-white relative overflow-hidden">
			{/* Background decoration */}
			<div className="absolute inset-0 overflow-hidden">
				<div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-900/20 rounded-full"></div>
				<div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-800/20 rounded-full"></div>
			</div>

			<div className="container mx-auto px-4 py-16 relative z-10">
				{/* Main Footer Content */}
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
					{/* Company Info */}
					<div className="lg:col-span-1">
						<Link to="/" className="inline-block mb-6">
							<img src={logoLight} alt="Logo" className="h-16" />
						</Link>
						<p className="text-gray-300 mb-6 leading-relaxed">
							Passionate Full-Stack Developer creating innovative digital solutions. 
							Let's build something amazing together.
						</p>
						<div className="flex space-x-4">
							{socialLinks.map((social, index) => (
								<motion.a
									key={social.label}
									href={social.href}
									target="_blank"
									rel="noopener noreferrer"
									whileHover={{ scale: 1.1, y: -2 }}
									whileTap={{ scale: 0.9 }}
									className="w-10 h-10 bg-gray-800 hover:bg-blue-600 text-gray-300 hover:text-white rounded-lg flex items-center justify-center transition-all duration-200"
									initial={{ opacity: 0, y: 20 }}
									animate={{ opacity: 1, y: 0 }}
									transition={{ delay: index * 0.1, duration: 0.5 }}
								>
									<social.icon className="w-5 h-5" />
								</motion.a>
							))}
						</div>
					</div>

					{/* Footer Links */}
					{footerLinks.map((section, sectionIndex) => (
						<div key={section.title}>
							<h3 className="text-lg font-semibold mb-4 text-white">
								{section.title}
							</h3>
							<ul className="space-y-3">
								{section.links.map((link, linkIndex) => (
									<li key={link.name}>
										<Link
											to={link.path}
											className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
										>
											{link.name}
										</Link>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

			

				{/* Bottom Footer */}
				<div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between">
					<div className="text-gray-400 text-sm mb-4 md:mb-0">
						© {currentYear} Awais Khan. All rights reserved.
					</div>
					<div className="flex items-center space-x-6 text-sm text-gray-400">
						<Link to="/privacy" className="hover:text-blue-400 transition-colors duration-200">
							Privacy Policy
						</Link>
						<Link to="/terms" className="hover:text-blue-400 transition-colors duration-200">
							Terms of Service
						</Link>
						<div className="flex items-center">
							Made with <FiHeart className="mx-1 text-red-500" /> by Awais Khan
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default AppFooter;
